module.exports = __webpack_public_path__ + "img/w27b.1b300a81.jpg";